export default __webpack_public_path__ + "./font/9e1bb626874ed49aa343d66b8d66ceaf.ttf";